define([
    'jquery',
    './vendor/jquery.photoswipe',
], function($) {
    'use strict';

    var init = function() {
        $('.js-gallery a').jqPhotoSwipe({
            forceSingleGallery: true
        });
    };

    return {
        init: init
    };
});
